import planReducer, { planApi, planDetailsApi } from '@reducers/plan/plan';

export { planApi, planDetailsApi } from '@reducers/plan/plan';

export const planMiddlewares = [planApi.middleware, planDetailsApi.middleware];
export const planReducers = {
  plan: planReducer,
  [planApi.reducerPath]: planApi.reducer,
  [planDetailsApi.reducerPath]: planDetailsApi.reducer,
};
